import React, { useContext, useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router';
import { apiClient } from '../../utils';
import { UserContext } from '../contexts';

export function SessionPage() {
  const search = useLocation().search;
  const params = new URLSearchParams(search);
  const loginCallback = params.get('logincallback');
  const returnTo = params.get('returnto');

  const [ready, setReady] = useState(false);
  const { user, setUser } = useContext(UserContext);

  useEffect(() => {
    apiClient
      .get('users/me')
      .then((response: any) => {
        if (response.data.email) {
          setUser(response.data);
        } else {
          setUser(undefined);
          setReady(true);
        }
      })
      .catch(() => {
        setUser(undefined);
        setReady(true);
      });
  }, [setUser]);

  return (
    <>
      {!user && ready && !loginCallback && <Redirect to={{ pathname: '/login-password', search: '?returnto=' + returnTo }} />}
      {!user && ready && loginCallback && <Redirect to={{ pathname: '/unauthorized' }} />}
      {user && <Redirect to={returnTo || '/'} />}
    </>
  );
}
